export const Slices = {
    Search: 'search',
    Prompts: 'prompts',
} as const;
